import { Noun } from '../../types'

const блядь: Noun = {
  type: 'noun',
  nominativeSingular: 'блядь',
  genitiveSingular: 'бляди',
  dativeSingular: 'бляди',
  accusativeSingular: 'блядь',
  instrumentalSingular: 'блядью',
  prepositionalSingular: 'бляди',
  nominativePlural: 'бляди',
  genitivePlural: 'блядей',
  dativePlural: 'блядям',
  accusativePlural: 'блядей',
  instrumentalPlural: 'блядями',
  prepositionalPlural: 'блядях',
}

export default блядь
